import { anyOf, arrayOf, enumOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

export const isConversationalInboundMessageTriggersSubscriptionGroup = objectOf({
  subscription_group: objectOf({
    id: string,
    name: string,
    channel: number,
  }),
  triggers: arrayOf(
    objectOf({
      type: enumOf("campaign", "canvas_entry", "canvas_exit", "canvas_action_path", "canvas_step"),
      id: anyOf(string, nullOrUndefined),
      name: anyOf(string, nullOrUndefined),
      step_name: anyOf(string, nullOrUndefined),
      path_name: anyOf(string, nullOrUndefined),
      keyword_category_name: anyOf(string, nullOrUndefined),
      has_additional_keyword_filters: boolean,
      subscription_group_id: string,
      restricted: boolean,
    })
  ),
  truncated: boolean,
});

export const isConversationalInboundMessageTriggersResult = objectOf({
  results: arrayOf(isConversationalInboundMessageTriggersSubscriptionGroup),
  limit: number,
});
